module.exports = __webpack_public_path__ + "img/icon_ysy.4a105ba7.png";